import Button from "atoms/buttons/button";
import { ButtonStyles } from "atoms/constants/button-styles";
import Paragraph from "atoms/typography/paragraph";
import { siteMap } from "internal-sitemap";
import EcommerceRedirectionModal from "organisms/subscription-card/ecommerce-redirection-modal";
import ContactModal from "pages/support/contact-modal";
import React, { useState } from "react";
import useModalActions from "utilities/hooks/use-modal-actions";
import { t } from "utilities/localization-utils";
import StringUtils from "utilities/string-utils";

const CSS_BASE_CLASS = "c-account-subscription-info-banner";
interface SubscriptionWarningBannerProps {
    daysUntilExpiration: number;
    userIsEnterpriseAdmin: boolean;
    displaySubscriptionWarning: boolean;
    subscriptionPin: string;
}
const SubscriptionWarningBanner = (props: SubscriptionWarningBannerProps) => {
    const {
        daysUntilExpiration,
        userIsEnterpriseAdmin,
        displaySubscriptionWarning,
        subscriptionPin,
    } = props;
    const [redirecting, setRedirecting] = useState(false);

    const {
        isOpen: isContactModalOpen,
        handleOpen: handleOpenContactModal,
        handleClose: handleCloseContactModal,
    } = useModalActions();

    const day = StringUtils.pluralize(daysUntilExpiration!, t("day"));

    const subscriptionOnClick = userIsEnterpriseAdmin
        ? handleOpenContactModal
        : () => setRedirecting(true);

    return (
        <div className={`${CSS_BASE_CLASS} -warning`}>
            <div className={`${CSS_BASE_CLASS}__content`}>
                {displaySubscriptionWarning && (
                    <Paragraph cssClassName={`${CSS_BASE_CLASS}__description`}>
                        <strong>{t("warning")}: </strong>
                        <span>
                            {t("warning-subscriptionWarning-description", {
                                timeToExpiration: `${daysUntilExpiration} ${day.toLowerCase()}`,
                            })}
                        </span>
                    </Paragraph>
                )}
            </div>
            {displaySubscriptionWarning && (
                <Button
                    cssClassName={`${CSS_BASE_CLASS}__button`}
                    style={ButtonStyles.Primary}
                    onClick={subscriptionOnClick}>
                    {t("warning-subscriptionWarning-buttonText")}
                </Button>
            )}
            {redirecting && (
                <EcommerceRedirectionModal
                    pin={subscriptionPin}
                    withPurchaseText={false}
                />
            )}
            {isContactModalOpen && (
                <ContactModal
                    closeDialog={handleCloseContactModal}
                    isVisible={true}
                    returnURL={siteMap.dashboards.user}
                    selectedReasonOption={t(
                        "contactReasons-renewEnterpriseSubscription"
                    )}
                />
            )}
        </div>
    );
};

export default SubscriptionWarningBanner;
